module.exports = __webpack_public_path__ + "static/media/logo-google-white.ce344b77.svg";